import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, Card, Button, Grid, Chip, Tooltip, Avatar, Link } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { fetchUser } from '../redux/ActionCreator';
import { apiRequest } from '../functions/apiRequest';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import BusinessIcon from '@mui/icons-material/Business';
import CakeIcon from '@mui/icons-material/Cake';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SchoolIcon from '@mui/icons-material/School';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GroupIcon from '@mui/icons-material/Group';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import StarIcon from '@mui/icons-material/Star';
import EventIcon from '@mui/icons-material/Event';


const token = localStorage.getItem('token');
const userID = parseInt(localStorage.getItem('userID'));

function ProfilePage() {

  const user = useSelector((state) => state.users.users);
  const dispatch = useDispatch();
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [netValue, setNetValue] = useState(0);
  const [clockedHours, setClockedHours] = useState(0);

  useEffect(() => {

    dispatch(fetchUser(token, userID));

    async function fetchData() {
      try {

        const data = await apiRequest('GET', false, `/cred/total?user_id=${userID}`)

        setTotalCredit(data[0].total_credit);
        setTotalDebit(data[0].total_debit);
        setNetValue(data[0].net);
        setClockedHours(data[0].hours);
      } catch (error) {
        setTotalCredit(0);
        setTotalDebit(0);
        setNetValue(0);
      }

    }

    fetchData()
    // eslint-disable-next-line
  }, []);

  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)',
        minHeight: '100vh',
        fontFamily: 'Raleway',
        paddingTop: 40,
        paddingBottom: 40,
      }}
    >
      <Grid item xs={12} md={10} lg={10} xl={8}>
        <Card elevation={6} style={{ borderRadius: 30, padding: 32, background: '#fff' }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={4} style={{ textAlign: 'center' }}>
              <img
                alt={'profile'}
                className='responsive'
                style={{
                  borderRadius: '50%',
                  width: 160,
                  height: 160,
                  objectFit: 'cover',
                  boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
                  border: '6px solid #e0e7ef',
                  marginBottom: 16,
                }}
                src={user['profile_pic']}
              />
              <Typography variant="h5" style={{ fontWeight: 700, marginTop: 8 }}>
                {user['first_name']} {user['last_name']}
              </Typography>
              <Typography variant="subtitle1" color="textSecondary" style={{ marginBottom: 8 }}>
                User ID: #{user['id']}
              </Typography>
              <Button href='/edit/profile' variant="outlined" size="small" style={{ borderRadius: 20, marginTop: 8 }}>
                <EditIcon fontSize="small" /> Edit Profile
              </Button>
              {/* Organization, Account Type, Community, Roles */}
              {user['org_name'] && user['org_name'] !== 'nil' && (
                <Typography variant="body2" style={{ marginTop: 12, color: '#1976d2' }}>
                  <BusinessIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  {user['org_name']}
                </Typography>
              )}
              {user['community'] && (
                <Chip label={user['community']} size="small" style={{ marginTop: 8, marginRight: 4, background: '#fce4ec', color: '#ad1457' }} />
              )}
              {user['roles'] && user['roles'].length > 0 && (
                <div style={{ marginTop: 8 }}>
                  {user['roles'].map((role, idx) => (
                    <Chip key={role+idx} label={role} size="small" icon={<VerifiedUserIcon style={{ color: '#43a047' }} />} style={{ marginRight: 4, background: '#e8f5e9', color: '#388e3c' }} />
                  ))}
                </div>
              )}
              {/* LinkedIn */}
              {user['linkedin_url'] && (
                <div style={{ marginTop: 8 }}>
                  <Tooltip title="LinkedIn Profile">
                    <Link href={user['linkedin_url']} target="_blank" rel="noopener">
                      <LinkedInIcon fontSize="large" style={{ color: '#0a66c2' }} />
                    </Link>
                  </Tooltip>
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                {/* Stats Row */}
                <Grid item xs={12} sm={6}>
                  <Card elevation={2} style={{ borderRadius: 20, padding: 20, background: '#f0f4fa', textAlign: 'center' }}>
                    <Typography variant="subtitle2" color="primary" style={{ fontWeight: 600 }}>Clocked Hours</Typography>
                    <Typography variant="h5" style={{ fontWeight: 700, marginTop: 8, color: '#1976d2' }}>{user['clocked_hours'] || clockedHours}</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card elevation={2} style={{ borderRadius: 20, padding: 20, background: '#f0f4fa', textAlign: 'center' }}>
                    <Typography variant="subtitle2" color="primary" style={{ fontWeight: 600 }}>My Credits</Typography>
                    <Typography variant="h5" style={{ fontWeight: 700, marginTop: 8 }}>
                      <a href={'/team/credit/' + user['id']} style={{ textDecoration: 'none', color: '#1976d2' }}>{user['creds'] || totalCredit}</a>
                    </Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                <a href={'/myprograms'} style={{ textDecoration: 'none', color: '#1976d2' }}>
                  <Card elevation={2} style={{ borderRadius: 20, padding: 20, background: '#f0f4fa', textAlign: 'center' }}>
                    <Typography variant="subtitle2" color="primary" style={{ fontWeight: 600 }}>Programs</Typography>
                    <Typography variant="h5" style={{ fontWeight: 700, marginTop: 8, color: '#1976d2' }}>
                      My Programs
                    </Typography>
                  </Card>
                  </a>
                </Grid>
                <Grid item xs={12} sm={6}>
                <a href={'/myevents'} style={{ textDecoration: 'none', color: '#1976d2' }}>
                  <Card elevation={2} style={{ borderRadius: 20, padding: 20, background: '#f0f4fa', textAlign: 'center' }}>
                    <Typography variant="subtitle2" color="primary" style={{ fontWeight: 600 }}>Events</Typography>
                    <Typography variant="h5" style={{ fontWeight: 700, marginTop: 8, color: '#1976d2' }}>
                     My Events
                    </Typography>
                  </Card>
                  </a>
                </Grid>
                {/* Account Balance, Debits, Unique ID, HL Active */}
                {/* <Grid item xs={12} sm={6}>
                  <Card elevation={1} style={{ borderRadius: 20, padding: 16, background: '#fffde7', textAlign: 'center' }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#fbc02d' }}><AccountBalanceWalletIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> Account Balance</Typography>
                    <Typography variant="h6" style={{ fontWeight: 700, marginTop: 8 }}>{user['account_balance']}</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card elevation={1} style={{ borderRadius: 20, padding: 16, background: '#ffebee', textAlign: 'center' }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#d32f2f' }}><StarIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> Debits</Typography>
                    <Typography variant="h6" style={{ fontWeight: 700, marginTop: 8 }}>{user['debits']}</Typography>
                  </Card>
                </Grid> */}
                {/* <Grid item xs={12} sm={6}>
                  <Card elevation={1} style={{ borderRadius: 20, padding: 16, background: '#e3f2fd', textAlign: 'center' }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2' }}><GroupIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> Unique ID</Typography>
                    <Typography variant="h6" style={{ fontWeight: 700, marginTop: 8 }}>{user['user_uuid']}</Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card elevation={1} style={{ borderRadius: 20, padding: 16, background: '#e8f5e9', textAlign: 'center' }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#388e3c' }}><VerifiedUserIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> HL Active</Typography>
                    <Typography variant="h6" style={{ fontWeight: 700, marginTop: 8 }}>{user['is_hl_active'] ? 'Yes' : 'No'}</Typography>
                  </Card>
                </Grid> */}
              </Grid>
              {/* Details Section */}
              <Grid container spacing={2} style={{ marginTop: 24 }}>
                <Grid item xs={12} sm={6}>
                  <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20, marginBottom: 12 }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8 }}><CakeIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> DOB / Age</Typography>
                    <Typography style={{ fontSize: 16 }}>{user['dob'] ? `${user['dob']} (${user['age']})` : 'N/A'}</Typography>
                  </Card>
                  {/* Address */}
                  {(user['address'] && user['address'] !== 'nil' && user['address'].trim() !== '' && user['address'].toLowerCase() !== 'nill') && (
                    <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20, marginBottom: 12 }}>
                      <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8 }}><LocationOnIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> Address</Typography>
                      <Typography style={{ fontSize: 16 }}>{user['address']}</Typography>
                    </Card>
                  )}
                  {/* School / College / Course */}
                  {((user['school'] && user['school'] !== 'nil' && user['school'].trim() !== '') || (user['college'] && user['college'] !== 'nil' && user['college'].trim() !== '') || (user['course'] && user['course'] !== 'nil' && user['course'].trim() !== '')) && (
                    <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20, marginBottom: 12 }}>
                      <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8 }}><SchoolIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> School / College / Course</Typography>
                      <Typography style={{ fontSize: 16 }}>
                        {[user['school'], user['college'], user['course']].filter(val => val && val !== 'nil' && val.trim() !== '').join(', ')}
                      </Typography>
                    </Card>
                  )}
                  {user['skills'] && user['skills'].length > 0 && (
                    <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20, marginBottom: 12 }}>
                      <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8 }}><StarIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> Skills</Typography>
                      <div>
                        {user['skills'].map((skill, idx) => (
                          <Chip key={skill+idx} label={skill} size="small" style={{ marginRight: 4, marginBottom: 4, background: '#fffde7', color: '#fbc02d' }} />
                        ))}
                      </div>
                    </Card>
                  )}
                  {/* <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20, marginBottom: 12 }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8 }}><EventIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> Account Created</Typography>
                    <Typography style={{ fontSize: 16 }}>{user['created_at'] ? new Date(user['created_at']).toLocaleDateString() : 'N/A'}</Typography>
                  </Card> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20, marginBottom: 12 }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8 }}><i className='material-icons' style={{ verticalAlign: 'middle', fontSize: 18 }}>email</i> Email</Typography>
                    <Typography style={{ fontSize: 16 }}>{user['email_id']}</Typography>
                  </Card>
                  <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20, marginBottom: 12 }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#1976d2', marginBottom: 8 }}><i className='material-icons' style={{ verticalAlign: 'middle', fontSize: 18 }}>smartphone</i> Mobile</Typography>
                    <Typography style={{ fontSize: 16 }}>{user['mobile_number']}</Typography>
                  </Card>
             
                 
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" style={{ fontWeight: 700, color: '#1976d2', marginBottom: 8 }}>About</Typography>
              <Card elevation={0} style={{ borderRadius: 16, background: '#f8fafc', padding: 20 }}>
                <Typography style={{ fontFamily: 'Raleway', fontSize: 18, color: '#333' }}>
                  {user['about'] || 'No information provided.'}
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}

export default ProfilePage;
